"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
require("./cookies-consent.css");
var _iconCross = _interopRequireDefault(require("./icon-cross.png"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _matomoTrackerReact = require("@datapunt/matomo-tracker-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//Composant template fenêtre de consentement
const WindowForConsent = _ref => {
  let {
    userCloseConsentWindow,
    userConsentCookies,
    userNotConsentCookies
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cookie-consent"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cookie-consent__title-container"
  }, /*#__PURE__*/_react.default.createElement("h1", null, "G\xE9rer le consentement aux cookies"), /*#__PURE__*/_react.default.createElement("img", {
    onClick: userCloseConsentWindow,
    src: _iconCross.default,
    alt: "croix"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cookie-consent__text-container"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Pour offrir les meilleures exp\xE9riences, nous utilisons des technologies telles que les cookies pour stocker et/ou acc\xE9der aux informations des appareils. Le fait de consentir \xE0 ces technologies nous permettra de traiter des donn\xE9es telles que le comportement de navigation ou les ID uniques sur ce site. Le fait de ne pas consentir ou de retirer son consentement peut avoir un effet n\xE9gatif sur certaines caract\xE9ristiques et fonctions.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "cookie-consent__button-container"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: userConsentCookies,
    id: "cookie-consent__button-accepter",
    variant: "contained"
  }, "Accepter"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: userNotConsentCookies,
    id: "cookie-consent__button-refuser",
    variant: "outlined"
  }, "Refuser")), /*#__PURE__*/_react.default.createElement("div", {
    className: "cookie-consent__link-container"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.agam.org/politique-de-cookies-ue/",
    target: "_blank",
    rel: "noreferrer"
  }, "Politique de cookies"), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.agam.org/politique-de-confidentialite/",
    target: "_blank",
    rel: "noreferrer"
  }, "Politique de confidentialit\xE9")));
};
const AgamRgpd = _ref2 => {
  let {
    children,
    url
  } = _ref2;
  const nomDuCookie = "agamconsentcookies";
  const dureeDuCookieEnJours = 365;
  const [cookieConsentExist, setCookieConsentExist] = (0, _react.useState)(undefined);
  const [valueCookieConsent, setValueCookieConsent] = (0, _react.useState)(undefined);

  //créé un cookie si l'utilisateur accepte ou refuse le consentement ( true ou false selon le cas)
  function setCookie(nameOfCookie, valueOfCookie, expirationDate) {
    const d = new Date();
    d.setTime(d.getTime() + expirationDate * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = nameOfCookie + "=" + valueOfCookie + ";" + expires + "path=/".concat(url);
  }

  //cherche si le cookie existe déjà, et regarde sa valeur (true / false ) pour activer ou non le tracking
  function getCookie(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let allCookies = decodedCookie.split(";");
    for (let i = 0; i < allCookies.length; i++) {
      let cookie = allCookies[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        setCookieConsentExist(true);
        const cookieValue = cookie.substring(name.length, cookie.length);
        if (cookieValue === "true") {
          setValueCookieConsent(true);
          return;
        }
        if (cookieValue === "false") {
          setValueCookieConsent(false);
          return;
        }
      }
    }
    setCookieConsentExist(false);
    return "not cookie consent";
  }

  //créé le cookie avec la valeur "true"
  function userConsentCookies() {
    setCookie(nomDuCookie, true, dureeDuCookieEnJours);
    setCookieConsentExist(true);
    setValueCookieConsent(true);
  }

  //créé le cookie avec la valeur "false"
  function userNotConsentCookies() {
    setCookie(nomDuCookie, false, dureeDuCookieEnJours);
    setCookieConsentExist(true);
    setValueCookieConsent(false);
  }

  //l'utilisateur ferme la fenêtre de consentement avec la croix. Aucun cookies n'est créé
  function userCloseConsentWindow() {
    document.querySelector('.cookie-consent').className = 'cookie-consent--hidden';
  }

  //Matomo
  function identifiant(max) {
    return Math.floor(Math.random() * max);
  }

  //Matomo
  const instance = (0, _matomoTrackerReact.createInstance)({
    urlBase: "http://spot.agam.org/".concat(url, "/"),
    siteId: 1,
    userId: "Utilisateur_TDB_".concat(identifiant(1000)),
    // optional, default value: `undefined`.
    trackerUrl: 'https://agam.matomo.cloud/matomo.php',
    // optional, default value: `${urlBase}matomo.php`
    srcUrl: 'https://agam.matomo.cloud/matomo.js',
    // optional, default value: `${urlBase}matomo.js`
    disabled: false,
    // optional, false by default. Makes all tracking calls no-ops if set to true.
    heartBeat: {
      // optional, enabled by default
      active: true,
      // optional, default value: true
      seconds: 10 // optional, default value: `15
    },

    linkTracking: false,
    // optional, default value: true
    configurations: {
      // optional, default value: {}
      // any valid matomo configuration, all below are optional
      disableCookies: true,
      setSecureCookie: true,
      setRequestMethod: 'POST'
    }
  });
  (0, _react.useEffect)(() => {
    getCookie(nomDuCookie);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cookieConsentExist === false ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(WindowForConsent, {
    userCloseConsentWindow: userCloseConsentWindow,
    userConsentCookies: userConsentCookies,
    userNotConsentCookies: userNotConsentCookies,
    setCookieConsentExist: setCookieConsentExist
  }, children)) : null, valueCookieConsent && /*#__PURE__*/_react.default.createElement(_matomoTrackerReact.MatomoProvider, {
    value: instance
  }, children), !valueCookieConsent && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children));
};
var _default = AgamRgpd;
exports.default = _default;